var _path, _rect, _rect2, _path2, _rect3, _rect4, _rect5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpAndFaqBlueIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 13.5C3 7.84314 3 5.01472 4.75735 3.25735C6.51472 1.5 9.34314 1.5 15 1.5H21C26.6568 1.5 29.4853 1.5 31.2426 3.25735C33 5.01472 33 7.84314 33 13.5V19.5C33 25.1568 33 27.9853 31.2426 29.7426C29.4853 31.5 26.6568 31.5 21 31.5H15C9.34314 31.5 6.51472 31.5 4.75735 29.7426C3 27.9853 3 25.1568 3 19.5V13.5Z",
    fill: "url(#paint0_linear_16739_118115)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 7.5,
    width: 15,
    height: 18,
    rx: 1.5,
    stroke: "white",
    strokeOpacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 6.5,
    width: 14,
    height: 17,
    rx: 1.5,
    fill: "#2D60E0",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0465 12.9075C19.2564 13.1251 19.333 13.4307 19.297 13.7263C19.2447 14.1552 19.1209 14.5569 18.9756 14.9618C18.8202 15.3951 18.6624 15.8274 18.5039 16.2595C18.2503 16.951 17.9947 17.6416 17.7439 18.3341C17.6816 18.506 17.6372 18.6897 17.6194 18.8714C17.6001 19.0692 17.7424 19.1666 17.921 19.0788C18.0641 19.0084 18.2034 18.9127 18.3155 18.7994C18.4985 18.6143 18.6808 18.4283 18.8586 18.238C18.9475 18.1429 19.0354 18.0467 19.1217 17.9491C19.1904 17.8712 19.261 17.7542 19.3553 17.7068C19.5339 17.6172 19.6717 17.8377 19.6394 17.9921C19.6085 18.1398 19.5068 18.2693 19.4133 18.3872L19.4068 18.3953C19.3983 18.406 19.3899 18.4167 19.3815 18.4274C19.0671 18.8272 18.7224 19.2128 18.3313 19.5387C17.9468 19.8582 17.52 20.13 17.0512 20.3063C16.8985 20.3637 16.7421 20.4109 16.5831 20.447C16.2761 20.5169 15.9368 20.5117 15.6231 20.4661C15.393 20.4327 15.1862 20.286 15.0887 20.0725C14.9195 19.7018 15.0373 19.2441 15.1248 18.8668C15.232 18.4049 15.3929 17.9651 15.5573 17.5226L15.5698 17.489L15.5761 17.4722L15.5886 17.4386L15.6011 17.4049C15.7916 16.892 15.9874 16.3812 16.1839 15.8707C16.3632 15.4049 16.5432 14.9395 16.7207 14.473C16.7342 14.4374 16.7493 14.402 16.7646 14.3667L16.7703 14.3534C16.8095 14.2629 16.8484 14.1723 16.863 14.0779C16.898 13.8514 16.7346 13.6497 16.5079 13.7803C16.1159 14.006 15.8223 14.3417 15.5314 14.6795L15.496 14.7205C15.4056 14.8255 15.3151 14.9303 15.2216 15.0316C15.1294 15.1314 15.0196 15.2552 14.8612 15.1408C14.692 15.0187 14.7422 14.8622 14.8383 14.7295C15.3722 13.9929 16.0131 13.3038 16.8484 12.9146C17.1975 12.752 17.6856 12.5864 18.1426 12.581C18.4852 12.577 18.8104 12.6629 19.0465 12.9075ZM19.5738 9.58494C20.0132 9.75594 20.25 10.138 20.25 10.6759C20.25 11.6452 19.203 12.3082 18.3277 11.8931C17.8753 11.6785 17.6553 11.17 17.765 10.5925C17.9168 9.79275 18.8179 9.29085 19.5738 9.58494Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 9.5,
    width: 4,
    height: 3,
    rx: 1.5,
    fill: "white",
    stroke: "#2D60E0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 13.5,
    width: 4,
    height: 3,
    rx: 1.5,
    fill: "white",
    stroke: "#2D60E0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 17.5,
    width: 4,
    height: 3,
    rx: 1.5,
    fill: "white",
    stroke: "#2D60E0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16739_118115",
    x1: 18,
    y1: 1.5,
    x2: 18,
    y2: 31.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D60E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D60E0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpAndFaqBlueIcon);
export default __webpack_public_path__ + "static/media/HelpAndFAQBlueIcon.a16c5bc892dbb0e23a6f65a9e9a385fa.svg";
export { ForwardRef as ReactComponent };